export default __webpack_public_path__ + "static/media/bangku.bdf20abf.jpg";